import { buildPublicSiteUrl } from './publicSiteUrl';

const PENDING_JOIN_TOKEN_KEY = 'lockedin_pending_join_token';

export function setPendingJoinToken(token) {
  if (!token || typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(PENDING_JOIN_TOKEN_KEY, String(token).trim());
  } catch (_) {
    /* ignore */
  }
}

export function peekPendingJoinToken() {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage.getItem(PENDING_JOIN_TOKEN_KEY);
  } catch (_) {
    return null;
  }
}

export function consumePendingJoinToken() {
  if (typeof window === 'undefined') return null;
  try {
    const value = window.sessionStorage.getItem(PENDING_JOIN_TOKEN_KEY);
    window.sessionStorage.removeItem(PENDING_JOIN_TOKEN_KEY);
    return value;
  } catch (_) {
    return null;
  }
}

export function buildJoinLeagueUrl(token) {
  if (!token) return '/join/';
  return buildPublicSiteUrl(`/join/${encodeURIComponent(token)}`);
}
